import { Dispatch, SetStateAction } from "react"

import { HomeFilterDropdownSelect } from "src/components/Filter/HomeFilterDropdown"
import {
  TLogFilterContext,
  usePostLogFilterApplied,
  usePostLogFilterCleared,
  usePostLogFilterHomeSearched,
  usePostLogFilterInitiated,
} from "src/data/analytics/queries/logAnalyticsQueries"

type HomeLogHomeFilterDropdownSelectProps = {
  homeIds: string[]
  setHomeIds: Dispatch<SetStateAction<string[]>>
  metaData: { context: TLogFilterContext }
}

export function HomeLogHomeFilterDropdownSelect({
  homeIds,
  setHomeIds,
  metaData,
}: HomeLogHomeFilterDropdownSelectProps) {
  const postLogFilterApplied = usePostLogFilterApplied()
  const postLogFilterHomeSearched = usePostLogFilterHomeSearched()
  const postLogFilterCleared = usePostLogFilterCleared()
  const postLogFilterInitiated = usePostLogFilterInitiated()

  function handleHomeSearch(searchValue: string) {
    if (!!searchValue) {
      postLogFilterHomeSearched.mutate({
        search_term: searchValue,
        context: metaData.context,
      })
    }
  }

  function handleHomeSelected(homeId: string, numOfHomes: number) {
    postLogFilterApplied.mutate({
      filter_type: "home",
      num_of_homes: numOfHomes,
      context: metaData.context,
    })
  }

  function handleClearSelection() {
    postLogFilterCleared.mutate({
      filter_type: "home",
      context: metaData.context,
    })
  }

  function handleDropdownClick() {
    postLogFilterInitiated.mutate({
      filter_type: "home",
      context: metaData.context,
    })
  }

  return (
    <HomeFilterDropdownSelect
      homeIds={homeIds}
      setHomeIds={setHomeIds}
      onHomeSearch={handleHomeSearch}
      onHomeSelected={handleHomeSelected}
      onClearSelection={handleClearSelection}
      onDropdownClick={handleDropdownClick}
    />
  )
}
